import { Link } from "wouter";
import { WidgetPanel } from "@/components/dashboard-grid/WidgetPanel";
import { ORIGINATION_SOURCE_LABELS, type OriginationSourceType } from "@shared/originationConstants";
import type { OriginationPayload } from "@shared/dashboardOrigination";
import { HBars } from "./HBars";
import { CLIENT_BG, SERIES_BG } from "./opsColors";

export function WhereItComesFrom({ o }: { o: OriginationPayload }) {
  const { withSource, total } = o.sourceCoverage;
  return (
    <WidgetPanel title="Where it comes from" meta="prospects and mandates by source">
      {o.sources.length === 0 ? (
        <p className="px-3 py-4 text-sm text-muted-foreground">No sources recorded yet.</p>
      ) : (
        <HBars
          rows={o.sources.map((s) => ({
            label: ORIGINATION_SOURCE_LABELS[s.sourceType as OriginationSourceType] ?? s.sourceType,
            value: s.prospects + s.clients,
            segments: [{ value: s.prospects, className: SERIES_BG }, { value: s.clients, className: CLIENT_BG }],
          }))}
          footer={
            <span className="flex flex-wrap items-center gap-x-3 gap-y-1">
              <span className="inline-flex items-center gap-1"><span className={`w-2 h-2 rounded-sm ${SERIES_BG}`} />Prospect</span>
              <span className="inline-flex items-center gap-1"><span className={`w-2 h-2 rounded-sm ${CLIENT_BG}`} />Became a client</span>
              {withSource < total && (
                <span>Only {withSource} of {total} have a source recorded. <Link href="/prospects" className="text-primary-text hover:underline">Set sources</Link></span>
              )}
            </span>
          }
        />
      )}
    </WidgetPanel>
  );
}
